<template>
  <div class="zfb-merchant-container">
    <div class="zfb-merchant-header">
      支付宝商户号-支付交易投诉
    </div>

    <!-- 页面区域 -->
    <div class="zfb-merchant-content">
      <!-- 商户号列表 -->
      <div class="merchant-list" v-loading="merchantLoading">
        <div :class="['merchant-list-item', selectMerchantId === item.id ? 'select-merchant-item' : '']" v-for="(item, index) in merchantList" :key="index" @click="handleSelectMerchant(item)">
          <div class="merchant-name" :style="{ maxWidth: item.pending_num ?'180px' : '220px' }">{{ item.name }}</div>
          <div v-if="item.pending_num" class="merchant-count">{{ `(${item.pending_num})` }}</div>
        </div>
      </div>

      <!-- 页面查询 -->
      <div class="merchant-search">
        <!-- 数据展示 -->
        <!-- <div class="search-content-header">
          <div class="num-content">
            <div class="num-content-item">待处理：100</div>
            <div class="num-content-item">已处理：3</div>
            <div class="num-content-item">处理完成率：10%</div>
          </div>
          <div class="searh-toooltip">
            <el-tooltip class="item" effect="dark" placement="top">
              <div slot="content">
                <p>待处理：近30天内发起的投诉单，当前处于待处理状态的单数。</p>
              </div>
              <i class="el-icon-warning-outline"></i>
            </el-tooltip>
          </div>
        </div> -->

        <!-- 表格展示 -->
        <div class="search-content-table">
          <div class="search-content-table-header">
            <BaseForm
              ref="baseform"
              :model.sync="searchForm"
              inline
              :formItems="searchFormItems"
              label-width="110px"
              @search="handleSearch"
              @reset="handleReset"
            />
          </div>

          <div class="search-content-table-body">
            <BaseTableGroup
              ref="baseTableGroup"
              border
              :columns="columns"
              :data="tableData"
              :total="total"
              :loading="listLoading"
              showPage
              maxHeight="500px"
              :page="searchForm.page"
              :pageSize="searchForm.limit"
              @pageChange="onPageChange"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- 完成处理 -->
    <ProcessCompleted ref="processCompleted" @success="handleComplete" />

    <!-- 投诉单详情 -->
    <ZfbComplaintFormDetail ref="complaintFormDetail" />
  </div>
</template>


<script>
import BaseForm from '@/components/common/BaseForm/BaseForm.vue';
import BaseTableGroup from '@/components/common/BaseTable/baseTableGroup.vue';

import RenderDom from '@/utils/renderDom';
import ZfbComplaintFormDetail from './complaintFormDetail.vue';
import ProcessCompleted from './processCompleted.vue';
import { getZfbMerchantListApi, getZfbComplaintStatusApi, getZfbComplaintListApi } from '@/api/merchant_complain_handle';
import { getDate, debounce } from '@/utils/utils';
import clipboard from '@/utils/clipboard';

class DefaultSearchForm {
  constructor () {
    this.id = ''; // 商户号ID
    this.page = 1;
    this.limit = 50;
    this.gmt_complaint_start = getDate(-29, '', '{y}-{m}-{d} {h}:{i}:{s}'); // 投诉时间
    this.gmt_complaint_end = getDate(0, '', '{y}-{m}-{d} {h}:{i}:{s}'); // 投诉时间
    this.task_id = ''; // 单号
    this.trade_no = ''; // 交易单号
    this.status_list = []; // 投诉状态
    this.gmt_process_start = ''; // 处理开始时间
    this.gmt_process_end = ''; // 处理结束时间
  }
}

export default {
  name: 'WxMerchantPage',
  components: {
    BaseForm,
    BaseTableGroup,
    RenderDom,
    ProcessCompleted,
    ZfbComplaintFormDetail
  },
  data() {
    return {
      wxMerchant: '',
      wxMerchantOptionList: [], // 微信商户号下拉列表
      merchantList: [],
      selectMerchantId: '',
      complaintStatusOptions: [],

      searchForm: new DefaultSearchForm(),
      tableData: [],
      total: 0,
      listLoading: false,
      merchantLoading: false
    };
  },
  computed: {
    columns () {
      return [
        {
          label: '投诉单号',
          key: 'task_id',
          'show-overflow-tooltip': false,
        },
        // 外层全部状态枚举
        // 用户撤诉: DROP_COMPLAIN
        // 超时后用户撤诉: DROP_OVERDUE_COMPLAIN
        // 超时处理完成用户撤诉: DROP_OVERDUE_PROCESSED
        // 处理完成用户撤诉: DROP_PROCESSED
        // 超时未处理: OVERDUE
        // 超时处理完成: OVERDUE_PROCESSED
        // 部分超时未处理: PART_OVERDUE
        // 处理完成: PROCESSED
        // 处理中: PROCESSING
        // 待处理: WAIT_PROCESS
        {
          label: '状态',
          key: 'status_description'
        },
        {
          label: '支付金额(元)',
          key: 'complain_amount',
        },
        {
          label: '交易单号',
          key: 'trade_no',
          'show-overflow-tooltip': false,
          render: (h, params) => {
            const { trade_no = '' } = params.row
            return (
              <div>
                {
                  trade_no && (
                    <div>
                      <div>
                        <el-tooltip content={trade_no} placement="top">
                          <div style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{trade_no}</div>
                        </el-tooltip>
                      </div>
                      <el-button type="text" size="mini" onClick={(e) => this.handleCopyTradeNo(trade_no, e)}>复制</el-button>
                    </div>
                  )
                }
              </div>
            )
          }
        },
        {
          label: '投诉内容',
          key: 'complain_content',
          'show-overflow-tooltip': false,
          render: (h, params) => {
            const { complain_content = '' } = params.row
            return (
              <div>
                {
                  complain_content && (
                    <div>
                      <div>
                        <el-tooltip content={complain_content} placement="top">
                          <div class="zfb-complain_content_ellipsis">{complain_content}</div>
                        </el-tooltip>
                      </div>
                    </div>
                  )
                }
              </div>
            )
          }
        },
        {
          label: '投诉时间',
          key: 'gmt_complain',
        },
        {
          label: '操作',
          key: 'operation',
          width: 150,
          fixed: 'right',
          render: (h, params) => {
            const { status } = params.row
            return (
              <div>
                <el-link type="primary" size="mini" underline={false} onClick={() => this.handleSearchDetailInfo(params.row)}>详情</el-link>

                {/* 待处理、处理中、超时未处理可以完成处理 */}
                {
                  ['WAIT_PROCESS', 'PROCESSING', 'OVERDUE'].includes(status) &&
                  <el-link type="primary" underline={false} style="margin-left: 10px;" size="mini" onClick={() => this.handleFinished(params.row)}>完成处理</el-link>
                }
              </div>
            )
          },
        }
      ]
    },
    searchFormItems () {
      return [
        {
          label: '投诉时间',
          child: {
            renderType: 'dateTimeRange',
            value: [this.searchForm.gmt_complaint_start, this.searchForm.gmt_complaint_end],
            beginTime: this.searchForm.gmt_complaint_start,
            endTime: this.searchForm.gmt_complaint_end,
            'update:beginTime': (time) => {
              this.searchForm.gmt_complaint_start = time
            },
            'update:endTime': (time) => {
              this.searchForm.gmt_complaint_end = time
            },
            styles: { width: '350px' },
            change: debounce((time) => {
              if (time) {
                const time_stamp = new Date(time[1]) - new Date(time[0])
                const time_diff = (time_stamp / 86400000) + 1
                if (time_diff > 32) {
                  this.searchForm.gmt_complaint_start = getDate(-29, '', '{y}-{m}-{d} {h}:{i}:{s}')
                  this.searchForm.gmt_complaint_end = getDate(0, '', '{y}-{m}-{d} {h}:{i}:{s}')
                  this.$message.error('起始时间间隔不能超过32天')
                  return false
                }
              }
            }, 0, false),
            clearable: false
          }
        },
        {
          label: '投诉单号',
          child: {
            renderType: 'input',
            valueKey: 'task_id',
            maxlength: 128,
            // 'show-word-limit': true,
          }
        },
        {
          label: '交易单号',
          child: {
            renderType: 'input',
            valueKey: 'trade_no',
            maxlength: 128,
            // 'show-word-limit': true,
          }
        },
        {
          label: '投诉状态',
          child: {
            renderType: 'cascader',
            valueKey: 'status_list',
            'collapse-tags': true,
            placeholder: '请选择投诉状态',
            props: {
              multiple: true,
              emitPath: false,
              children: 'child',
              label: 'title',
              value: 'flag',
            },
            options: this.complaintStatusOptions
          }
        },
        {
          label: '处理时间',
          child: {
            renderType: 'dateTimeRange',
            value: [this.searchForm.gmt_process_start, this.searchForm.gmt_process_end],
            beginTime: this.searchForm.gmt_process_start,
            endTime: this.searchForm.gmt_process_end,
            'update:beginTime': (time) => {
              this.searchForm.gmt_process_start = time
            },
            'update:endTime': (time) => {
              this.searchForm.gmt_process_end = time
            },
            styles: { width: '350px' },
            clearable: true,
            change: debounce((time) => {
              if (time) {
                const time_stamp = new Date(time[1]) - new Date(time[0])
                const time_diff = (time_stamp / 86400000) + 1
                if (time_diff > 32) {
                  this.searchForm.gmt_process_start = ''
                  this.searchForm.gmt_process_end = ''
                  this.$message.error('起始时间间隔不能超过32天')
                  return false
                }
              }
            }, 0, false),
          }
        },
        {
          label: '搜索',
          type: 'primary',
          renderType: 'search'
        },
        {
          label: '重置',
          renderType: 'reset'
        },
      ]
    }
  },
  mounted () {
    this.getMerchantList()
    this.getZfbComplaintStatus()
  },
  methods: {
    // 获取支付宝商户号列表
    getMerchantList () {
      this.merchantLoading = true
      getZfbMerchantListApi().then(res => {
        const { data } = res
        this.merchantList = data.data || []
        if (!this.selectMerchantId) {
          this.selectMerchantId = this.merchantList[0].id || ''
          this.searchForm.id = this.selectMerchantId
          this.handleGetTableData()
        }
        this.merchantLoading = false
      }).catch(() => {
        this.merchantLoading = false
      })
    },

    // 完成处理
    handleComplete () {
      this.getMerchantList()
      this.handleGetTableData()
    },

    // 获取支付宝投诉状态下拉筛选
    getZfbComplaintStatus () {
      getZfbComplaintStatusApi().then(res => {
        const { data } = res
        this.complaintStatusOptions = data.data || []
      }).catch(() => {})
    },
    handleSearch () {
      this.searchForm.page = 1
      this.handleGetTableData()
    },
    handleReset () {
      this.searchForm = {
        ...new DefaultSearchForm(),
        id: this.selectMerchantId
      }
      this.handleGetTableData()
    },


    handleGetTableData () {
      const { id, gmt_complaint_start, gmt_complaint_end } = this.searchForm
      if (!this.searchForm.id) {
        this.$message.error('请选择商户')
        return
      }

      if (!gmt_complaint_start || !gmt_complaint_end) {
        this.$message.error('请选择投诉时间')
        return
      }

      this.listLoading = true
      getZfbComplaintListApi(this.searchForm).then(res => {
        const { data } = res.data
        this.tableData = data.data || []
        this.total = data.total || 0
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
      })
    },

    onPageChange (page) {
      this.searchForm.page = page.page || 1
      this.searchForm.limit = page.limit || 50
      this.handleGetTableData()
    },

    // 复制单号
    handleCopyTradeNo (trade_no, event) {
      clipboard(trade_no, event)
    },

    handleSelectMerchant (item) {
      this.selectMerchantId = item.id
      this.searchForm.id = item.id
      this.handleGetTableData()
    },

    // 查看详情
    handleSearchDetailInfo (row) {
      this.$refs.complaintFormDetail.triggleVisible({
        id: this.selectMerchantId,
        complain_id: row.id
      })
    },

    // 完成处理
    handleFinished (row) {
      this.$refs.processCompleted.triggleVisible({
        ...row,
        selectMerchantId: this.selectMerchantId
      })
    }
  }
};
</script>


<style lang="scss">
.zfb-complain_content_ellipsis {
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

</style>
<style lang="scss" scoped>
.zfb-merchant-container {
  .zfb-merchant-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.zfb-merchant-content {
  display: flex;
  // flex-direction: column;
  gap: 30px;
  margin-top: 15px;
  .merchant-list {
    min-width: 250px;
    width: 250px;
    height: 100%;
    min-height: 365px;
    background-color: #fff;
    border-radius: 5px;
    // padding: 0 10px;
    overflow: hidden;

    .select-merchant-item {
      background-color: #cde8f6;
    }

    .merchant-list-item {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 45px;
      line-height: 45px;
      border-bottom: 1px solid #e5e5e5;
      padding: 0 10px;
      box-sizing: border-box;
      cursor: pointer;

      .merchant-name {
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .merchant-count {
        color: red;
      }
    }
  }
  .merchant-search {
    flex: 1;
  }

  .merchant-search {
    width: 100%;
    .search-content-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .num-content {
        display: flex;
        gap: 20px;
        .num-content-item {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }

    .search-content-table {
      // margin-top: 15px;
      // width: 100%;
      .search-content-table-header {
        background: #fff;
        border-radius: 5px;
        padding: 20px;
        margin-bottom: 20px;
      }
    }
    .search-content-table-body {
      // width: 100%;
      background: #fff;
      border-radius: 5px;
      padding: 20px;
    }
  }
}
</style>
